import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Employees from './pages/Employees/Employees'
import Clients from './pages/Clients/Clients'
import Projects from './pages/Projects/Projects'
import Timesheets from './pages/Timesheets'
import TimeOff from './pages/TimeOff/TimeOff'
import Invoices from './pages/Invoices/Invoices'
import Reports from './pages/Reports'
import Profile from './pages/Profile'
import Welcome from './pages/Welcome'
import UpcomingEvents from './pages/UpcomingEvents'
import OurTeam from './pages/OurTeam'
import Notes from './pages/Notes'
import Fitpass from './pages/Fitpass/Fitpass'
import Lunch from './pages/Lunch/Lunch'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import Layout from './components/Layout'
import { Box } from '@mui/material'
import AddEmployee from './pages/Employees/AddEmployee';
import AddClient from './pages/Clients/AddClient';
import AddProject from './pages/Projects/AddProject';
import AddInvoice from './pages/Invoices/AddInvoice'; 
import EditEmployee from './pages/Employees/EditEmployee';
import EditClient from './pages/Clients/EditClient';
import EditProject from './pages/Projects/EditProject';
import EditInvoice from './pages/Invoices/EditInvoice'

function App() {
  return (
    <AuthProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%', bgcolor: 'background.default', color: 'text.primary' }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/welcome" replace />} />
            
            {/* Admin-only routes */}
            <Route path="dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
            <Route path="employees" element={<AdminRoute><Employees /></AdminRoute>} />
            <Route path="employees/add" element={<AdminRoute><AddEmployee /></AdminRoute>} />
            <Route path="employees/:id/edit" element={<AdminRoute><EditEmployee /></AdminRoute>} />
            <Route path="clients" element={<AdminRoute><Clients /></AdminRoute>} />
            <Route path="clients/add" element={<AdminRoute><AddClient /></AdminRoute>} />
            <Route path="clients/:id/edit" element={<AdminRoute><EditClient /></AdminRoute>} />
            <Route path="projects" element={<AdminRoute><Projects /></AdminRoute>} />
            <Route path="projects/add" element={<AdminRoute><AddProject /></AdminRoute>} />
            <Route path="projects/:id/edit" element={<AdminRoute><EditProject /></AdminRoute>} />
            <Route path="invoices" element={<AdminRoute><Invoices /></AdminRoute>} />
            <Route path="invoices/add" element={<AdminRoute><AddInvoice /></AdminRoute>} />
            <Route path="invoices/:id/edit" element={<AdminRoute><EditInvoice /></AdminRoute>} />
            <Route path="reports" element={<AdminRoute><Reports /></AdminRoute>} />
            
            {/* Employee-accessible routes */}
            <Route path="welcome" element={<Welcome />} />
            <Route path="upcoming-events" element={<UpcomingEvents />} />
            <Route path="our-team" element={<OurTeam />} />
            <Route path="notes" element={<Notes />} />
            <Route path="timesheets" element={<Timesheets />} />
            <Route path="time-off" element={<TimeOff />} />
            <Route path="fitpass" element={<Fitpass />} />
            <Route path="lunch" element={<Lunch />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
      </Box>
    </AuthProvider>
  )
}

export default App 